import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import AppRouter from './components/pages/AppRouter'

const Router = () => (
  <BrowserRouter>
    <Switch>
      <AppRouter />
      <Route>
        {/* eslint-disable-next-line */}
        <div>🤖 404! Beep-boop. Page not found.</div>
      </Route>
    </Switch>
  </BrowserRouter>
)

export default Router
